import { getInitialState, getPath } from "../../utils";

const initialState = {
  userPropertyList: [],
  prevPage: -1,
  nextPage: -1,
  activeUserProperty: {},
  activeFilters: {},
  currentPage: 1,
  keysList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_USER_PROPERTY_LIST":
      return setUserPropertyList(state, action);
    case "SET_ACTIVE_USER_PROPERTY":
      return setActiveUserProperty(state, action);
    case "SET_ACTIVE_FILTERS":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_USER_PROPERTY":
      return setCurrentPageUserProperty(state, action);
    case "RESET_STATE_USER_PROPERTY":
      return resetStateFeature(state, action);
    case "SET_USER_PROPERTY_KEYS":
      return setUserPropertyKeys(state, action);
    default:
      return state;
  }
}

const setCurrentPageUserProperty = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setUserPropertyList = (state, action) => {
  return {
    ...state,
    userPropertyList: getPath(action.payload, "data.user_properties", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};

const resetStateFeature = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveUserProperty = (state, action) => {
  return {
    ...state,
    activeUserProperty: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setUserPropertyKeys = (state, action) => {
  return {
    ...state,
    keysList: action.payload,
  };
};
